import { render } from "./AuthItems.vue?vue&type=template&id=16bdc478&scoped=true"
import script from "./AuthItems.vue?vue&type=script&lang=js"
export * from "./AuthItems.vue?vue&type=script&lang=js"

import "./AuthItems.vue?vue&type=style&index=0&id=16bdc478&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16bdc478"]])

export default __exports__